import {useMutation} from "@apollo/client";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_CHECKS_QUERY2, GQL_UPDATE_GROUPED_CHECK_SERVICES} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkAddToGroupCheckForm} from "@/pages/checks/list/actions/bulkAddToGroupCheck/BulkAddToGroupCheckForm.tsx";

export interface AddToGroupCheckFormValues {
  group_check_id?: number | undefined;
}

export interface BulkAddToGroupCheckModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkAddToGroupCheckModal = ({
  selectedItemsIds,
  show,
  setShow,
  onSuccess,
}: BulkAddToGroupCheckModalProps) => {
  const [updateGroupCheckChecks, {data, loading}] = useMutation<GraphQLResponse<null>>(
    GQL_UPDATE_GROUPED_CHECK_SERVICES,
    {
      refetchQueries: [GQL_CHECKS_QUERY2],
    }
  );

  const handleSubmit = async (data: AddToGroupCheckFormValues) => {
    const response = await updateGroupCheckChecks({
      variables: {
        ids: selectedItemsIds,
        group_check_id: data.group_check_id,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkAddToGroupCheckForm";
  return (
    <FormModal
      size="lg"
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={"Add checks to group"}
      hasRequiredFields
    >
      <BulkAddToGroupCheckForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
